import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-intro',
  templateUrl: './intro.component.html',
  styleUrls: ['./intro.component.css']
})
export class IntroComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<IntroComponent>) { }

  ngOnInit() {
  }
  close(){
    this.dialogRef.close();
  }

}
